module.exports = __webpack_public_path__ + "static/img/5.5e00afe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/zh/5.png
// module id = NbK+
// module chunks = 0